import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  canceledTag: {
    color: '#F44336',
    borderColor: '#F44336',
  },
  tableRow: {
    backgroundColor: 'white',
  },
  accountMenu: {
    boxShadow: 'none',
  },
  menuIcon: {
    marginRight: '12px',
    fontSize: '1.5rem',
  },
  starColor: {
    color: '#039BE5',
  },
  starListIcon: {
    fontSize: '2rem',
  },
  validateDocumentsButton: {
    textTransform: 'none',
    marginTop: 25,
  },
}));
